import React from 'react';
import { Box, Typography, LinearProgress } from 'components/ui';

const Usage = ({ value, valueBuffer, label }) => {
  value = Math.min(value, valueBuffer);

  return (
    <Box mt={2}>
      <Typography variant="body2" gutterBottom>
        {label} {value} / {valueBuffer}
      </Typography>
      <LinearProgress variant="determinate" value={value / valueBuffer * 100} />
    </Box>
  );
};

export default Usage;
